/* ============
 * All Packaging Types
 * ============
 *
 * All packaging types from a product.
 */

import Vue from 'vue';
import store from '../../store';
import packagingTypeTransformer from '../../transformers/packagingType';

const success = ({ data }, resolve) => {
  const packagingTypes = packagingTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchPackagingTypes', packagingTypes);
  resolve();
};

const failed = () => {
};

// Display packaging types related to a product.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('packaging_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/packagingType/all.js